<template>
	<edit-layout @save="handleSave()" @cancel="$emit('browsMode')" class="video-form">
		<VideoDescTop></VideoDescTop>
		<el-form ref="ruleForm" :model="video" label-position="left">
			<el-popover trigger="hover" title="提示" placement="top">
				<span style="color:red;">如欲參加分享季，請確認影片已上傳</span>
				<div slot="reference">
					<el-form-item label="故事影片連結" class="form-item" prop="src" :rules="{ required:true, message:'YouTube 連結或是雲端連結' }">
						<el-input v-model="video.src" class="input" placeholder="（可為 YouTube 連結或是雲端連結）"></el-input>
					</el-form-item>
				</div>
			</el-popover>
		</el-form>
		<VideoDescBottom></VideoDescBottom>
	</edit-layout>
</template>

<script>
import EditLayout from "./EditLayout.vue";
import VideoDescTop from "./VideoDescTop.vue";
import VideoDescBottom from "./VideoDescBottom.vue";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	data() {
		return {
			video: {}
		};
	},
	computed: {
		...mapState("story", ["editStoryData"])
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		init() {
			this.video = { ...this.editStoryData.video };
		},
		handleSave() {
			this.$refs["ruleForm"].validate(async valid => {
				if (valid) {
					let data = {
						id: this.editStoryData.id,
						video: this.video
					};
					this.updateEditStoryData(data);
					data.progress = await this.checkProgress();
					await this.updateStory(data);
					this.$emit("browsMode");
					this.$message.success("儲存成功");
				}
			})
		},
		validator(rule, value, callback) {
			if (!value || /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/.test(value)) {
				callback();
			} else callback(new Error("請貼上 Youtube 網址"));
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {
		EditLayout,
		VideoDescTop,
		VideoDescBottom
	}
};
</script>

<style lang="scss" scoped>
.video-form {
	font-size: 14px;

	.input {
		width: 350px;
	}

	.story-video {
		margin-top: 26px;
	}

	.ori-video {
		margin-top: 22px;
	}

	.viedo-description {
		padding-left: 100px;
		font-size: 12px;
		margin-top: 17px;

		.link-tips {
			margin-bottom: 35px;
		}

		.names-description {
			margin-bottom: 25px;
		}

		.names-rules {
			margin-bottom: 25px;
		}
	}
}
</style>